













































































import { LessonEntity } from '@/entities/lesson.entity';
import { PropType } from 'vue';
import Component from 'vue-class-component';
import { Inject, Prop } from 'vue-property-decorator';
import VuePdf from 'vue-pdf/src/vuePdfSss.vue';
import { UseService } from '@/services/service';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import GraduationHatIcon from '@/components/Helper/Icon/Svg/GraduationHatIcon.vue';
import { SurveyQuestionResultEntity } from '@/entities/survey-question-result.entity';
import SurveyQuestionResultService from '@/services/survey-question-result.service';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import { SurveyQuestionResultSuccessEntity } from '@/entities/survey-question-result-success.entity';
import SurveyQuestionResultSuccessService from '@/services/survey-question-result-success.service';
import moment from 'moment';

@Component<SurveyQuestionELearningItem>({
  components: {
    GraduationHatIcon,
    VuePdf,
    SurveyQuestionELearningItem,
  },
  filters: {
    formatDate(date, locale) {
      let dateType = 'DD/MM/YYYY';
      if (locale === 'ja') dateType = 'YYYY/MM/DD';
      return moment(date).format(dateType);
    },
  },
  data: () => ({
    surveyQuestionResults: [],
    surveyQuestionResultSuccess: null,
  }),
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
  async created() {
    this.surveyQuestionResultSuccess = await this.surveyQuestionResultSuccessService.check();
    console.log(this.surveyQuestionResultSuccess);
    if (this.surveyQuestionResultSuccess && !this.surveyQuestionResultSuccess.isSuccess) {
      this.surveyQuestionResults = await this.surveyQuestionResultService.getMany(
        this.currentStaff.id,
        this.surveyQuestionResultSuccess.notifyId,
        this.currentStaff.companyId,
      );
    }
  },
})
export default class SurveyQuestionELearningItem extends CreateListDataMixin<LessonEntity>(
  'lesson',
  'lesson',
  [],
  [['id', 'DESC']],
  20,
) {
  @Prop({ type: Object as PropType<LessonEntity> })
  lesson: LessonEntity;

  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  currentStaff!: StaffEntity;

  notifySurveyQuestion: { notifyId: number; staffId: number } = null;

  surveyQuestionResults: SurveyQuestionResultEntity[] = [];

  surveyQuestionResultSuccess: SurveyQuestionResultSuccessEntity;

  @UseService(SurveyQuestionResultService)
  surveyQuestionResultService: SurveyQuestionResultService;

  @UseService(SurveyQuestionResultSuccessService)
  surveyQuestionResultSuccessService: SurveyQuestionResultSuccessService;

  getLearntPercentCount(lesson: LessonEntity): number {
    const learntPages = lesson?.learnProgress?.pages || [];
    const percent = Number(learntPages.length) / (lesson.totalPage || learntPages.length);
    return percent * 100;
  }
  get questionsDone() {
    let num = 0;
    this.surveyQuestionResults.forEach((item) => {
      if (item.surveyQuestionPointId) {
        num += 1;
      }
    });
    return num;
  }

  get isSuccess(): boolean {
    if (!this.surveyQuestionResultSuccess) return false;
    return this.surveyQuestionResultSuccess.isSuccess ?? false;
  }

  get getDate(): String {
    if (!this.surveyQuestionResults.length && !this.surveyQuestionResultSuccess) return '';
    let date: Date;
    if (this.surveyQuestionResultSuccess) date = this.surveyQuestionResultSuccess?.updatedAt;
    else date = this.surveyQuestionResults[0]?.updatedAt;
    if (this.$i18n.locale === 'ja') return moment(date).format('YYYY/MM/DD');
    return moment(date).format('DD/MM/YYYY');
  }
}
